import LinkedInIcon from 'assets/icons/linkedin.svg';
import TwitterIcon from 'assets/icons/twitter-x.svg';

const SocialIcons = () => {
  const baseUrl = window.location.origin;
  const url = encodeURIComponent(baseUrl);
  const text = encodeURIComponent(
    `Check out Compass by ICONIQ! The most critical data and insights, highlighting the core performance metrics and trends across Compass software benchmarks, with 38,000+ data points spanning over 12 years of quarterly data.\n\n${baseUrl}`
  );

  return (
    <div className='flex gap-4 absolute bottom-1 right-0'>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
        target='_blank'
        rel='noreferrer noopener'
        className='border-none'
      >
        <img src={LinkedInIcon} alt='linkedin' />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?text=${text}`}
        target='_blank'
        rel='noreferrer noopener'
        className='border-none'
      >
        <img src={TwitterIcon} alt='twitter' />
      </a>
    </div>
  );
};

export default SocialIcons;
